import { Outlet } from "react-router-dom";
import { useGlobalState } from "../components/global";
import { useEffect } from "react";
import SideMenu from "../components/side_menu";

function Operator() {
    const { navActive } = useGlobalState();

    useEffect(() => {
        navActive("/operator");
    }, []);

    return <div className="module module-operator" style={{ display: 'grid', gridTemplateColumns: '260px 1fr' }}>
        <div className="side-menu">
            <SideMenu />
        </div>
        <div className="content" style={{ overflowY: "auto", overflowX: "hidden" }}>
            <Outlet />
        </div>
    </div>

}

export default Operator;